<template>
  <div class="mobilePage" :class="{ ios: os.isPhone }">
    <div class="pageB" :class="{ storePack: isIosStore }">
      <img class="sceneBg" src="@/assets/images/mobile1/pageB/v2/bg.png" alt="" />
      <img
        class="sceneHero"
        src="@/assets/images/mobile1/pageB/v2/hero.png"
        alt=""
      />
      <img
        class="sceneTitle"
        src="@/assets/images/mobile1/pageB/v2/title.png"
        alt="别光看封面，点开更有戏"
      />
      <div class="header">
        <div class="brand">
          <img
            class="brandIcon"
            src="@/assets/images/mobile1/pageA/logo-icon.webp"
            alt=""
          />
          <img
            class="brandText"
            src="@/assets/images/mobile1/pageA/logo-text.webp"
            alt="黄果免费看"
          />
        </div>
        <div class="contactBox">
          <div v-if="swUrl" class="contactItem" @click="toPage(swUrl)">
            <img
              class="contactIcon contactIconSw"
              src="@/assets/images/mobile1/pageB/v2/icon-sw.png"
              alt=""
            />
            <span class="contactText">商务合作</span>
          </div>
          <div v-if="tgUrl" class="contactItem" @click="toPage(tgUrl)">
            <img
              class="contactIcon contactIconTg"
              src="@/assets/images/mobile1/pageB/v2/icon-tg.png"
              alt=""
            />
            <span class="contactText">官方群组</span>
          </div>
          <div v-if="qdUrl" class="contactItem" @click="toPage(qdUrl)">
            <img
              class="contactIcon contactIconQd"
              src="@/assets/images/mobile1/pageB/v2/icon-qd.png"
              alt=""
            />
            <span class="contactText">渠道合作</span>
          </div>
        </div>
      </div>
      <div class="downloadBox">
        <img
          v-if="os.isPhone"
          class="downBtn"
          src="@/assets/images/mobile1/pageB/v2/btn-ios.png"
          alt="苹果下载"
          @click.stop="getApkInfo('ios', $event)"
        />
        <template v-else>
          <img
            class="downBtn"
            src="@/assets/images/mobile1/pageB/v2/btn-android.png"
            alt="安卓下载"
            @click.stop="getApkInfo('android', $event)"
          />
          <img
            v-if="showSpareDownload"
            class="downBtn"
            src="@/assets/images/mobile1/pageB/v2/btn-spare.png"
            alt="备用下载"
            @click.stop="getApkInfo('androidSpare', $event)"
          />
        </template>
      </div>
      <div v-if="isIosStore" class="storeBanner">
        <p class="storeAge">本站内容仅限18周岁以上用户访问</p>
        <div class="storeBar">
          <button
            type="button"
            class="storeSide"
            @click.stop="getApkInfo('ios', $event)"
          >
            点击前往
          </button>
          <button
            type="button"
            class="storeMain"
            @click.stop="getApkInfo('ios', $event)"
          >
            <span class="appleMark" aria-hidden="true"></span>
            <span>苹果商店</span>
            <span class="storeDown">下载</span>
          </button>
          <button
            type="button"
            class="storeSide"
            @click.stop="getApkInfo('ios', $event)"
          >
            立即前往
          </button>
        </div>
      </div>
      <div v-else class="footerTip">
        <p>提示：本APP属于特殊行业，偶尔会误报毒提醒，如有报毒提示，</p>
        <p>请点击忽略，并开启飞行模式安装即可！</p>
      </div>
    </div>

    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果提示框 -->
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";
export default {
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  computed: {
    showSpareDownload() {
      const data = this.switchData || {};
      return Boolean(data.androidDownUrl && data.channelApkAndDownUrl);
    },
    isIosStore() {
      const data = this.switchData || {};
      return Boolean(this.os && this.os.isPhone && data.shopIosDownUrl);
    }
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
        return newValue;
      });
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    const referrer = sessionStorage.getItem("referrer");
    const dc = sessionStorage.getItem("dc");
    if (referrer && dc) {
      this.currUrl = referrer + "user.html?dc=" + dc;
    } else {
      if (referrer) {
        this.currUrl = referrer + "user.html";
      } else {
        this.currUrl = window.location.href;
      }
    }
    // 预加载安装教程弹窗背景（藏在 display:none 的 overlay 里不会自动拉取），
    // 防止弹出时正赶上下载跳转被中断
    new Image().src = require("@/assets/images/mobile1/iosTip.webp");
    new Image().src = require("@/assets/images/mobile1/android_tip.png");
  },
  methods: {
    // 剪贴板
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    checkIsSafari() {
      let ua = this.os.userAgent.toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      const data = this.switchData || {};
      const isIos = this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos
        ? data.shopIosDownUrl || data.iosDownUrl
        : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.getApkInfo(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）；自动触发时无点击事件，不上报
      if (!event) return;
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    toPage(path) {
      window.open(path);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.mobilePage {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  .pageB {
    position: relative;
    width: 100%;
    min-height: max(100%, 768px);
    background: #fdc5ca;

    .sceneBg {
      position: fixed;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 0;
      pointer-events: none;
    }

    .sceneHero {
      position: absolute;
      left: 50%;
      top: 0;
      width: 375px;
      max-width: 100%;
      height: auto;
      transform: translateX(-50%);
      z-index: 1;
      pointer-events: none;
    }

    &.storePack {
      .sceneTitle {
        bottom: 150px;
      }

      .downloadBox {
        bottom: 119px;
      }
    }

    .sceneTitle {
      position: fixed;
      left: 50%;
      bottom: 50px;
      width: 375px;
      max-width: 100%;
      height: auto;
      transform: translateX(-50%);
      z-index: 2;
      pointer-events: none;
    }

    .header {
      box-sizing: border-box;
      height: calc(47px + env(safe-area-inset-top));
      padding: env(safe-area-inset-top) 8px 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgba(10, 10, 10, 0.39);
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10;
    }

    .brand {
      display: flex;
      align-items: center;
      gap: 6px;
      flex: 0 0 auto;
      .brandIcon {
        width: 30px;
        height: 30px;
        border-radius: 6px;
      }
      .brandText {
        width: 67.5px;
        height: 31.5px;
      }
    }

    .contactBox {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .contactItem {
      width: 66.5px;
      height: 19px;
      box-sizing: border-box;
      border-radius: 9.5px;
      background: #fc0466;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      cursor: pointer;
    }

    .contactIcon {
      filter: brightness(0) invert(1);
    }

    .contactIconSw {
      width: 7.5px;
      height: 11px;
    }

    .contactIconTg {
      width: 11px;
      height: 9px;
    }

    .contactIconQd {
      width: 11px;
      height: 11px;
    }

    .contactText {
      font-size: 10px;
      line-height: 10px;
      font-family: -apple-system, "PingFang SC", "Helvetica Neue",
        "Microsoft YaHei", sans-serif;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      white-space: nowrap;
    }

    .downloadBox {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 59px;
      z-index: 4;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }

    .downBtn {
      width: 128px;
      height: 44px;
      cursor: pointer;
    }

    .storeBanner {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 5;
      box-sizing: border-box;
      padding: 8px 12px calc(10px + env(safe-area-inset-bottom));
    }

    .storeAge {
      margin: 0 0 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: #fff;
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      text-shadow: 0 1px 2px rgba(0, 40, 120, 0.35);

      &::before,
      &::after {
        content: "";
        width: 28px;
        height: 1px;
        background: rgba(255, 255, 255, 0.9);
      }
    }

    .storeBar {
      height: 52px;
      border-radius: 26px;
      padding: 0 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: linear-gradient(90deg, #1f6dff 0%, #3aa6ff 100%);
      box-shadow: 0 4px 12px rgba(20, 90, 220, 0.28);
    }

    .storeSide,
    .storeMain {
      border: 0;
      padding: 0;
      color: #fff;
      background: transparent;
      cursor: pointer;
      font-family: -apple-system, "PingFang SC", "Helvetica Neue",
        "Microsoft YaHei", sans-serif;
    }

    .storeSide {
      flex: 0 0 72px;
      height: 28px;
      border-radius: 14px;
      background: rgba(255, 255, 255, 0.22);
      font-size: 12px;
      font-weight: 600;
    }

    .storeMain {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 1px;
    }

    .storeDown {
      font-size: 16px;
      font-weight: 600;
    }

    .appleMark {
      width: 16px;
      height: 18px;
      background: currentColor;
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 18'%3E%3Cpath d='M13.2 9.5c0-2.2 1.8-3.3 1.9-3.4-1-1.5-2.6-1.7-3.2-1.7-1.4-.1-2.6.8-3.3.8s-1.7-.8-2.9-.8c-1.5 0-2.8.9-3.6 2.2-1.5 2.7-.4 6.6 1.1 8.8.7 1.1 1.6 2.3 2.7 2.2 1.1 0 1.5-.7 2.8-.7s1.7.7 2.9.7 1.9-1.1 2.6-2.2c.8-1.2 1.1-2.3 1.2-2.4-.1 0-2.2-.8-2.2-3.5zM11 3.2c.6-.7 1-1.7.9-2.7-1 .1-2.1.6-2.7 1.4-.6.7-1.1 1.7-.9 2.6 1 .1 2.1-.5 2.7-1.3z'/%3E%3C/svg%3E")
        center / contain no-repeat;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 18'%3E%3Cpath d='M13.2 9.5c0-2.2 1.8-3.3 1.9-3.4-1-1.5-2.6-1.7-3.2-1.7-1.4-.1-2.6.8-3.3.8s-1.7-.8-2.9-.8c-1.5 0-2.8.9-3.6 2.2-1.5 2.7-.4 6.6 1.1 8.8.7 1.1 1.6 2.3 2.7 2.2 1.1 0 1.5-.7 2.8-.7s1.7.7 2.9.7 1.9-1.1 2.6-2.2c.8-1.2 1.1-2.3 1.2-2.4-.1 0-2.2-.8-2.2-3.5zM11 3.2c.6-.7 1-1.7.9-2.7-1 .1-2.1.6-2.7 1.4-.6.7-1.1 1.7-.9 2.6 1 .1 2.1-.5 2.7-1.3z'/%3E%3C/svg%3E")
        center / contain no-repeat;
    }

    .footerTip {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 36px;
      z-index: 5;
      box-sizing: border-box;
      background: rgba(27, 0, 46, 0.26);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 10px;
      font-weight: 600;
      line-height: 14px;
      color: #fff;
      font-family: -apple-system, "PingFang SC", "Helvetica Neue",
        "Microsoft YaHei", sans-serif;

      p {
        margin: 0;
      }
    }
  }
  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/android_tip.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }

  .iosOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/iosTip.webp") no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      position: relative;

      .appName {
        font-size: 10px;
        font-weight: 500;
        color: #242423;
        position: absolute;
        left: 79px;
        bottom: 102px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .desc {
        font-size: 7px;
        font-weight: 500;
        color: #8f908f;
        position: absolute;
        left: 79px;
        bottom: 92px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }

  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
